(function(){
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const isElement = (node) => !!node && node.nodeType === 1;

  // Run a callback when the DOM is ready
  const onReady = (cb) => {
    if (typeof cb !== 'function') return;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb, { once: true });
    } else {
      cb();
    }
  };

  const getDirectH2 = (container) => {
    if (!isElement(container)) return null;
    try {
      const h2 = container.querySelector(':scope > h2');
      if (isElement(h2)) return h2;
    } catch (e) { /* fallback below if :scope is not supported */ }

    // Fallback for older browsers without :scope
    for (let i = 0; i < container.children.length; i += 1) {
      const child = container.children[i];
      if (isElement(child) && child.tagName === 'H2') return child;
    }
    return null;
  };

  const moveInstaFeedLink = (container) => {
    if (!isElement(container)) return false;

    const header = getDirectH2(container);
    if (!isElement(header)) return false;

    let linkWrapper = container.querySelector('.instafeed-bottom-link-wrapper');
    if (!isElement(linkWrapper)) {
      const parent = container.parentElement;
      if (isElement(parent)) {
        linkWrapper = parent.querySelector('.instafeed-bottom-link-wrapper');
      }
    }
    if (!isElement(linkWrapper)) {
      linkWrapper = document.querySelector('.instafeed-bottom-link-wrapper');
    }
    if (!isElement(linkWrapper)) return false;

    // Ensure the link inside behaves normally on click (no app interception)
    const ensureDefaultBehaviour = (wrapper) => {
      if (!isElement(wrapper)) return;
      const link = wrapper.querySelector('a');
      if (!isElement(link)) return;
      if (link.dataset && link.dataset.instaFeedClickBound === '1') return;

      const stop = (e) => {
        if (!e) return;
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        } else if (typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }
        // Do NOT call preventDefault — we want the browser to follow the href normally
      };

      const events = ['click', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'pointerdown', 'pointerup'];
      for (let i = 0; i < events.length; i += 1) {
        const evt = events[i];
        link.addEventListener(evt, stop, true);  // capture phase
        link.addEventListener(evt, stop, false); // bubble phase
      }

      try {
        link.dataset.instaFeedClickBound = '1';
      } catch (e) { /* noop */ }
    };

    // If it's already placed right after the h2, still ensure behavior and exit
    const next = header.nextElementSibling;
    if (next === linkWrapper) {
      ensureDefaultBehaviour(linkWrapper);
      return true;
    }

    // Move the element right after h2
    if (typeof header.insertAdjacentElement === 'function') {
      header.insertAdjacentElement('afterend', linkWrapper);
    } else if (header.parentNode === container) {
      const ref = header.nextSibling;
      container.insertBefore(linkWrapper, ref);
    } else {
      container.appendChild(linkWrapper);
    }

    // After moving, ensure default click behavior on the link
    ensureDefaultBehaviour(linkWrapper);
    return true;
  };

  const setupObserver = () => {
    const tryMove = () => {
      const container = document.getElementById('insta-feed');
      if (!isElement(container)) return false;
      return moveInstaFeedLink(container);
    };

    // First, try immediately in case everything is already on the page
    if (tryMove()) {
      return;
    }

    // Observe the whole document for dynamic insertion of the section (if supported)
    let docObserver = null;
    if (typeof MutationObserver !== 'undefined') {
      docObserver = new MutationObserver(() => {
        tryMove();
      });

      const root = document.documentElement || document.body;
      if (root) {
        docObserver.observe(root, { childList: true, subtree: true });
      }
    }

    // Also, if/when the container exists, observe changes inside it to catch late-added items
    const attachSectionObserver = () => {
      const container = document.getElementById('insta-feed');
      if (!isElement(container) || typeof MutationObserver === 'undefined') return;

      const sectionObserver = new MutationObserver(() => {
        tryMove();
      });

      sectionObserver.observe(container, { childList: true, subtree: true });
    };

    // Try to attach immediately and also on future changes
    attachSectionObserver();

    // In case the app re-renders and changes the DOM structure, attempt a few times after load
    let retries = 20; // ~10 seconds with 500ms interval
    const interval = window.setInterval(() => {
      if (tryMove()) {
        window.clearInterval(interval);
        return;
      }

      retries -= 1;
      if (retries <= 0) {
        window.clearInterval(interval);
      }

      attachSectionObserver();
    }, 500);

    // Expose a small API for debugging (optional, non-invasive)
    if (typeof window === 'object') {
      window.__InstaFeedFix = {
        moveNow: tryMove
      };
    }
  };

  onReady(setupObserver);
})();